// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__3wHC5","name":"ConsentHeader_name__3XTpG","birthday":"ConsentHeader_birthday__ptQQR","skeleton":"ConsentHeader_skeleton__3LO5K"};